export const TONE_OF_VOICE_DROP_DOWN_LABEL = 'Tone';
export const TEXT_LENGTH_DROP_DOWN_LABEL = 'Length';
